export const AuthUserRoute = {
  USER: { name: 'user', path: 'user' },
  PROFILE: {
    name: 'user-profile',
    path: 'profile'
  },
  ONBOARDING: {
    name: 'onboarding',
    path: 'onboarding'
  },
  ONBOARDING_FREE_WILL: {
    name: 'onboarding-free-will',
    path: 'free-will'
  },
  ONBOARDING_FLOW: {
    name: 'onboarding-flow',
    path: 'start'
  },
  ESTATE_SELECTION: {
    path: 'estate-selection',
    name: 'estate-selection'
  },
  VERIFY_EMAIL: {
    name: 'verify-email-sent',
    path: 'verify/email-sent'
  },
  OTP_SETUP: {
    name: 'otp-setup',
    path: 'otp-setup'
  }
};

export const AuthRoute = {
  LOGINLAYOUT: {
    path: '',
    name: 'loginlayout'
  },
  SIGNUP: {
    path: 'signup',
    name: 'signup'
  },
  SIGNUP_AFTERCARE: {
    path: 'sign-up/aftercare',
    name: 'sign-up-aftercare'
  },
  SIGNUP_SETTLEMENT: {
    path: 'sign-up/settlement',
    name: 'sign-up-settlement'
  },
  SIGNUP_STANDARD: {
    path: 'sign-up/online-will',
    name: 'sign-up-online-will'
  },
  SIGNUP_BASIC: {
    path: 'sign-up/basic',
    name: 'sign-up-basic'
  },
  SIGNUP_DIGITALVAULT: {
    path: 'sign-up/digital-vault',
    name: 'sign-up-digital-vault'
  },
  SIGNUP_PARTNERSELFSERVE: {
    path: 'sign-up/partner-self-serve',
    name: 'sign-up-partner-self-serve'
  },
  SIGNUP_BASIC_FRENCH: {
    path: 'sign-up/basic?lang=fr-qc',
    name: 'sign-up-basic-french'
  },
  SIGNUP_STANDARD_FRENCH: {
    path: 'sign-up/online-will?lang=fr-qc',
    name: 'sign-up-online-will-french'
  },
  SIGNUP_VAULT: {
    path: 'sign-up/vault',
    name: 'sign-up-vault'
  },
  SIGNUP_ADVISOR: {
    path: 'sign-up/advisor',
    name: 'sign-up-advisor'
  },
  SIGNUP_ADVISOR_PORTAL: {
    path: 'sign-up/advisor-portal',
    name: 'sign-up-advisor-portal'
  },
  LOGIN: {
    path: 'login',
    name: 'login'
  },
  OTP_LOGIN: {
    path: 'otp-login',
    name: 'otp-login'
  },
  VERIFY: {
    path: 'verify',
    name: 'verify'
  },
  INVITED: {
    path: 'invited',
    name: 'invited'
  },
  FORGOTPASSWORD: {
    path: 'forgot-password',
    name: 'forgot-password'
  },
  RESETPASSWORD: {
    path: 'reset-password',
    name: 'reset-password'
  },
  SSO_LOGIN: {
    path: 'sso-login',
    name: 'sso-login'
  }
};
